export default __webpack_public_path__ + "static/media/card-5.fc413fef.webp";